import { DateTime } from 'luxon';
import * as Logo from "../images/Usf.png";
import { Link } from './Link';

export function Footer(): JSX.Element {
  return (
    <footer className="bg-[#006747] mt-auto  ">
      <div className="flex flex-row flex-wrap py-8 px-9 sm:py-16 sm:px-20 items-center justify-evenly">
        <div className="max-lg:mb-10">
          {/* render image */}
          <img src={Logo} alt="USF logo" className=""/>
        </div>
        <div className="text-white">
          <p>
            {/* Display copyright information */}
            Copyright © {DateTime.now().year.toString()}, University of South Florida. All rights reserved.
          </p>
          <p>
            {/* Provide information about maintaining the website */}
            This website is maintained by the <Link to="mailto:honors-it@honors.usf.edu" external>
              Judy Genshaft Honors College</Link>.
          </p>
          <p className="mt-5">
            {/* Display contact and address information */}
            4202 E. Fowler Avenue, HON 1001<br />
            Tampa, FL 33620, USA • 813-974-3087
          </p>
        </div>
      </div>
    </footer>
  );
}
